import { FMSInterface, FMSType, StorageCommanderAuth } from "@swivl-mono/types";
import { Input } from "@swivl-mono/ui";
import React from "react";

interface Props {
  fms: FMSInterface;
  onBlur();
  onTokenChange(e: any);
  onDataChange(e: any);
}

export const FMSAPIColumn = (props: Props) => {
  const { fms, onBlur, onTokenChange, onDataChange } = props;
  const data = fms.data || {};
  const token = fms.token || {};

  const fields = React.useMemo(() => {
    if (fms.type === FMSType.SiteLink) {
      const corpCode = token.corpCode || "";
      const corpUserName = token.corpUserName || "";
      const corpPassword = token.corpPassword || "";
      return (
        <>
          <label>Lead Unit Id</label>
          <Input name="leadUnitId" value={data.leadUnitId} onChange={onDataChange} onBlur={onBlur} />

          <label>Logon corporate code</label>
          <Input name="corpCode" value={corpCode} onChange={onTokenChange} onBlur={onBlur} />

          <label>Logon username for the call center corporate user</label>
          <Input name="corpUserName" value={corpUserName} onChange={onTokenChange} onBlur={onBlur} />

          <label>Logon password for the call center corporate user</label>
          <Input name="corpPassword" type={Input.Type.Password} value={corpPassword} onChange={onTokenChange} onBlur={onBlur} />
        </>
      );
    }

    if (fms.type === FMSType.StorEdge) {
      const apiAccessId = token.apiAccessId || "";
      const apiSecretKey = token.apiSecretKey || "";
      return (
        <>
          <label>API Access Id</label>
          <Input name="apiAccessId" value={apiAccessId} onChange={onTokenChange} onBlur={onBlur} />

          <label>API Secret Key</label>
          <Input name="apiSecretKey" type={Input.Type.Password} value={apiSecretKey} onChange={onTokenChange} onBlur={onBlur} />
        </>
      );
    }

    // base_url: "https://edge.tenant.dev/api/v3/applications",
    // app_id: "appbc35600a675841eea5893df84231789e",
    // api_key: "25d2ff3ff21175294c6e705ad50007b4",

    if (fms.type === FMSType.Tenant) {
      const company_id = token.company_id || "";
      const base_url = token.base_url || "";
      const app_id = token.app_id || "";
      const api_key = token.api_key || "";

      return (
        <>
          <label>Company Id</label>
          <Input name="company_id" value={company_id} onChange={onTokenChange} onBlur={onBlur} />

          <label>Base URL</label>
          <Input name="base_url" value={base_url} onChange={onTokenChange} onBlur={onBlur} />

          <label>App Id</label>
          <Input name="app_id" value={app_id} onChange={onTokenChange} onBlur={onBlur} />

          <label>API Key</label>
          <Input name="api_key" value={api_key} onChange={onTokenChange} onBlur={onBlur} />
        </>
      );
    }

    if (fms.type === FMSType.SSM) {
      const url = token.url || "";

      const strCustomerCode = token.strCustomerCode || "";
      const strCustomerPassword = token.strCustomerPassword || "";

      return (
        <>
          <label>Customer Code</label>
          <Input name="strCustomerCode" value={strCustomerCode} onChange={onTokenChange} onBlur={onBlur} />

          <label>CustomerPassword</label>
          <Input name="strCustomerPassword" type={Input.Type.Password} value={strCustomerPassword} onChange={onTokenChange} onBlur={onBlur} />

          <label>URL</label>
          <Input name="url" value={url} onChange={onTokenChange} onBlur={onBlur} />
        </>
      );
    }

    if (fms.type === FMSType.StorageCommander) {
      const userId = (token as StorageCommanderAuth).userId || "";
      const apiKey = (token as StorageCommanderAuth).apiKey || "";

      return (
        <>
          <label>User Id</label>
          <Input name="userId" value={userId} onChange={onTokenChange} onBlur={onBlur} />

          <label>API Subscription Key</label>
          <Input name="apiKey" type={Input.Type.Password} value={apiKey} onChange={onTokenChange} onBlur={onBlur} />
        </>
      );
    }

    if (fms.type === FMSType.DoorSwap) {
      const username = token.username || "";
      const password = token.password || "";

      return (
        <>
          <label>Username</label>
          <Input name="username" value={username} onChange={onTokenChange} onBlur={onBlur} />

          <label>Password</label>
          <Input name="password" type={Input.Type.Password} value={password} onChange={onTokenChange} onBlur={onBlur} />
        </>
      );
    }

    if (fms.type === FMSType.SSMCloud) {
      const url = token.url || "";
      const userId = token.userId || "";
      const password = token.password || "";

      return (
        <div className="ssmValues">
          <br />
          <br />
          <label>User Id</label>
          <Input name="userId" value={userId} onChange={onTokenChange} onBlur={onBlur} />

          <label>Password</label>
          <Input name="password" type={Input.Type.Password} value={password} onChange={onTokenChange} onBlur={onBlur} />

          <label>URL</label>
          <Input name="url" value={url} onChange={onTokenChange} onBlur={onBlur} />
        </div>
      );
    }

    if (fms.type === FMSType.Storage360) {
      const apiKey = token.apiKey || "";
      const baseUrl = token.baseUrl || "";

      return (
        <>
          <label>API Key</label>
          <Input name="apiKey" value={apiKey} onChange={onTokenChange} onBlur={onBlur} />

          <label>Base Url</label>
          <Input name="baseUrl" value={baseUrl} onChange={onTokenChange} onBlur={onBlur} />
        </>
      );
    }

    if (fms.type === FMSType.Cubby) {
      const apiKey = token.apiKey || "";
      const baseUrl = token.baseUrl || "";
      const organizationId = token.organizationId || "";

      return (
        <>
          <label>API Key</label>
          <Input name="apiKey" value={apiKey} onChange={onTokenChange} onBlur={onBlur} />

          <label>Base Url</label>
          <Input name="baseUrl" value={baseUrl} onChange={onTokenChange} onBlur={onBlur} />

          <label>Organization Id</label>
          <Input name="organizationId" value={organizationId} onChange={onTokenChange} onBlur={onBlur} />
        </>
      );
    }
  }, [fms, data, token, onDataChange, onTokenChange, onBlur]);

  return (
    <>
      <h2>API Credentials</h2>
      Use these to connect to the {fms.type} API.
      <div className="apiValues">{fields}</div>
    </>
  );
};
